// Sensible defaults a race config can rely on.
export const DEFAULTS = {
  refreshIntervalMs: 60_000,
  financeRefreshEveryNTicks: 10, // ~10 min at a 60s tick; FEC IE totals barely move
  stalenessThresholdMs: 180_000, // 3 min
  divergenceFlagPct: 3, // percentage points
  snapshotCap: 500,
} as const;
